import Interests from "./Interests";

export default Interests;